module.exports = __webpack_public_path__ + "static/media/Corduroy-SS18-Milan_thumb.456edf10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrics-prints/Corduroy-SS18-Milan_thumb.jpg
// module id = 158
// module chunks = 0